import { Component, Input } from '@angular/core';
import { Attachment, File_Type } from 'src/app/models/RestModels';
import { RestService } from 'src/app/services/rest.service';

export interface AttachmentGalleryItem
{
	attachment: Attachment | null;
	file_type?: File_Type | null;
	title?: string | null;
}

/**
 * Galería de lectura de archivos adjuntos: las imágenes se muestran como
 * miniaturas (link a la imagen completa) y los demás archivos como links
 * con ícono de clip. Se usa en view-quote y view-order.
 */
@Component({
	selector: 'app-attachment-gallery',
	templateUrl: './attachment-gallery.component.html',
	styleUrls: ['./attachment-gallery.component.css']
})
export class AttachmentGalleryComponent
{
	@Input() items: AttachmentGalleryItem[] = [];

	constructor(public rest:RestService) { }

	isImage(item:AttachmentGalleryItem):boolean
	{
		if( item.file_type )
			return item.file_type.is_image == 'YES';

		return (item.attachment?.content_type || '').toLowerCase().startsWith('image/');
	}

	getTitle(item:AttachmentGalleryItem):string
	{
		return item.title || item.attachment?.original_filename || item.attachment?.filename || 'Archivo';
	}

	getFileUrl(item:AttachmentGalleryItem):string
	{
		return this.rest.getFilePath(item.attachment?.id as number);
	}

	getDownloadUrl(item:AttachmentGalleryItem):string
	{
		return this.rest.getFilePath(item.attachment?.id as number, true);
	}
}
